import {Model} from '@vuex-orm/core';
import DuaCategory from './DuaCategory';

export default class Dua extends Model {
    static entity = 'duas';

    static fields () {
        return {
            id: this.number(0),
            code: this.string(''),
            name: this.string(''),
            duacategory_id: this.number(null),
            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            category: this.belongsTo(DuaCategory, 'duacategory_id'),
        };
    }
}
